import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { FormPageLayout } from '@/components/layouts';
import { InvoiceDetailPage } from '@/components/organisms/invoices/InvoiceDetailPage';
import { InvoiceFormPage } from '@/components/organisms/invoices/InvoiceFormPage';
import { useInvoice } from '@/hooks/invoices/useInvoice';

export const Route = createFileRoute('/_dashboard/dashboard/jobs/$id/invoices/$invoiceId')({
  component: JobInvoiceRoute,
});

function JobInvoiceRoute() {
  const router = useRouter();
  const { id: jobId, invoiceId } = Route.useParams();
  const { data: invoice, isLoading } = useInvoice(invoiceId);
  const navigateBack = () =>
    void router.navigate({
      to: '/dashboard/jobs/$id',
      params: { id: jobId },
      search: { tab: 'finances' as const },
    });

  if (isLoading) {
    return (
      <FormPageLayout title="Invoice" onBack={navigateBack} noscroll>
        <div className="flex h-full items-center justify-center">
          <Loader2 className="size-4 animate-spin" />
        </div>
      </FormPageLayout>
    );
  }

  if (!invoice) {
    return (
      <FormPageLayout title="Invoice not found" onBack={navigateBack} noscroll>
        <div className="mx-auto max-w-lg px-4 py-6">
          <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive">
            Invoice not found.
          </div>
        </div>
      </FormPageLayout>
    );
  }

  if (invoice.status === 'draft') {
    return <InvoiceFormPage invoiceId={invoiceId} mode="edit" initialJobId={jobId} />;
  }

  return <InvoiceDetailPage invoiceId={invoiceId} jobContextId={jobId} />;
}
